import $ from 'jquery'

var filterMixins = {
  data () {
    return {
      keyword: '',
      isOpen: false,
      results: [],
      arrowCounter: -1
    }
  },
  props: {
    field: String,
    title: String,
    query: Object,
    items: Array,
    resetKeyword: Boolean,
    nChanges: Number,
    filterType: String
  },
  mounted () {
    $(this.$el).on('shown.bs.dropdown', e => this.$refs.input.focus())
    this.setOptions()
  },
  computed: {
    keywordIsSet () {
      return !!(this.query.assocFilters[this.field] || this.query.freeTextFilters[this.field])
    }
  },
  methods: {
    search (box) {
      const { query } = this
      if (this.filterType === 'Array') {
        this.$set(query.assocFilters, this.field, this.filterCategories)
      } else {
        this.$set(query.freeTextFilters, this.field, this.keyword)
      }
      query.offset = 0 // reset pagination
      query.filterIsActive = true
      // this.query.offset = 0
      this.$set(this.query, 'nChanges', this.query.nChanges + 1)
      if (box) box.isOpen = false
    },
    setResults (result) {
      this.keyword = result
      this.isOpen = false
      this.search()
    },
    onChange () {
      this.arrowCounter = -1
    },
    onArrowDown () {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1
      }
    },
    onArrowUp () {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1
      }
    },
    onEnter () {
      if (this.arrowCounter > -1) {
        this.keyword = this.results[this.arrowCounter]
      }
      this.isOpen = false
      this.arrowCounter = -1
      this.search()
    },
    deleteFilter (box) {
      this.$delete(this.query.freeTextFilters, this.field)
      this.$delete(this.query.assocFilters, this.field)
      this.$set(this.query, 'nChanges', this.query.nChanges + 1)
      if (this.boxes) this.$set(this.boxes, this.field, false)
      box.isOpen = !box.isOpen
    }
  },
  watch: {
    query: {
      handler () {
        this.keyword = this.query.freeTextFilters[this.field] || this.query.assocFilters[this.field]
      },
      deep: true
    },
    resetKeyword (rkw) {
      if (rkw) {
        this.keyword = undefined
      }
    }
  }
}

export default filterMixins



// WEBPACK FOOTER //
// ./src/components/plugins/filter-mixins.js